/** Full date format, displaying day, month and year (e.g. `04.05.2026`). */
const fullDateFormat = 'dd.MM.yyyy';

/** Short date format, displaying day and month (e.g. `04.05`). */
const shortDateFormat = 'dd.MM';

export { fullDateFormat, shortDateFormat };
